import { render, staticRenderFns } from "./PriceGroupCalculator.vue?vue&type=template&id=0620cf75&scoped=true"
import script from "./PriceGroupCalculator.vue?vue&type=script&lang=js"
export * from "./PriceGroupCalculator.vue?vue&type=script&lang=js"
import style0 from "./PriceGroupCalculator.vue?vue&type=style&index=0&id=0620cf75&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0620cf75",
  null
  
)

export default component.exports